import React from 'react';
import styles from './Separator.module.scss';

const separator = () => <hr className={styles.separator} />;

export default separator;
